export default __webpack_public_path__ + "static/media/mysql.fe2ca099.png";